import Icon from '../components/Icon.vue'

Icon.register({
  'chess-rook': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M368 32c8.8 0 16 7.2 16 16v176l-64 32c0 47.7 1.5 95 13.2 160h-282.4c11.7-65 13.2-111.7 13.2-160l-64-32v-176c0-8.8 7.2-16 16-16h56.1c8.8 0 16 7.2 16 16v48h47.9v-48c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16v48h48v-48c0-8.8 7.2-16 16-16h56zM224 320v-64c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64zM368 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-352c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/chess-rook.js
// module id = 1186
// module chunks = 0